export default function EnvironmentVariablePage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-2xl rounded-2xl bg-white p-6 shadow-lg">
        <h1 className="mb-4 text-2xl font-bold text-gray-800">
          Environment Variables
        </h1>
        <pre className="overflow-auto rounded-xl bg-gray-100 p-4 text-sm text-gray-700">
          {JSON.stringify(import.meta.env, null, 2)}
        </pre>
      </div>
    </div>
  );
}
